import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'de': {
        mietspiegel: {
            title: 'Mietspiegel für München 2025',
        },
        wartung: {
            texta: 'Wartungsankündigung: Der Mietspiegel wird am 14.10.2025 ab 9:00 bis 11:00 Uhr (CEST) gewartet und steht in der Zeit nicht zur Verfügung.',
            textb: 'Vielen Dank für Ihr Verständnis!',
        },
        warning: {
            select: 'Im Berechnungsschritt "%{step}" schließt die Auswahl von "%{choice}" die Auswahl %{currentStep}"%{currentChoice}" aus.'
        },
        save: {
            editError: "Name existiert bereits, wählen Sie einen neuen Namen!",
            validationError: 'Bitte geben Sie einen zulässigen Dateinamen (Sonderzeichen, außer " ", ".", "-", "_", nicht erlaubt) ein. <br/>Ihre Berechnung konnte nicht gespeichert werden.'
        },
        test: 'Hello World',
        wohnflaeche: {
            outOfRange: "Der Mietspiegel ist nur für Wohnungen mit einer Wohnfläche zwischen 20 und 160 m² anwendbar. Bitte ändern Sie Ihre Eingabe."
        },
        baujahr: {
            null: "",
            0: 'bis 1918',
            1: '1919-1929',
            2: '1930-1948',
            3: '1949-1966',
            4: '1967-1977',
            5: '1978-1988',
            6: '1989-1998',
            7: '1999-2008',
            8: '2009-2018',
            9: '2019-2021',
            10: '2022-2023',
            rueckgebaeudeError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Rückgebäude" die Auswahl von "%{currentChoice}" aus.',
            waermedaemmungError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Wärmedämmung der Außenwände" die Auswahl von "%{currentChoice}" aus.',
            fassadeAError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Besonders gestaltete Fassade" die Auswahl von "%{currentChoice}" aus.',
            fensterABError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Fenster mit Isolierverglasung" die Auswahl von "%{currentChoice}" aus.',
            balkonGrossError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Ein Balkon/Loggia größer als 10 m²" die Auswahl von "%{currentChoice}" aus.'
        },
        wohnlage: {
            null: "",
            0: 'Durchschnittliche Lage (im Stadtplan hellblau markiert)',
            1: 'Gute Lage (im Stadtplan gelb markiert)',
            2: 'Beste Lage (im Stadtplan hellrot markiert)',
            3: 'Zentrale durchschnittliche Lage (im Stadtplan dunkelblau markiert)',
            4: 'Zentrale gute Lage (im Stadtplan orange markiert)',
            5: 'Zentrale beste Lage (im Stadtplan dunkelrot markiert)'
        },
        Gebaeudetyp: 'Gebäudetyp',
        gebaeudetyp: {
            null: "",
            0: 'Hochhaus oder höheres Gebäude',
            1: 'Wohnblock',
            2: 'Anderer Gebäudetyp'
        },
        haustyp: {
            null: "",
            0: 'Sehr einfacher Altbau',
            1: 'Einfacher Altbau',
            2: 'Guter Altbau',
            3: 'Einfacher Nachkriegsbau',
            4: 'Anderer Haustyp'
        },
        Haustyp: 'Haustyp',
        heizung: {
            null: "",
            0: 'Ja',
            1: 'Nein'
        },
        fussbodenheizung: {
            null: "",
            0: 'Ja',
            1: 'Nein',
            // error: 'Ist in der Wohnung eine von der Vermieterin oder dem Vermieter gestellte Fußbodenheizung vorhanden, muss im Berechnungsschritt "%{step}" die Auswahl "%{choice}" getroffen werden.'
            error: "Fußbodenheizung \"ja\" findet nur Anwendung, wenn im Berechnungsschritt \"Baujahr\" ein Baujahr vor 1999 ausgewählt wurde."
        },
        Sanitaerbereich: "Sanitärbereich",
        sanitaerbereich: {
            0: 'Besondere Zusatzausstattung im Bad vorhanden',
            1: 'Handtuchheizkörper (nicht mit Strom betrieben) vorhanden',
            2: 'Separate bodengleiche Dusche',
            3: 'Fläche des (größten) Bades beträgt mindestens 6 m² und/oder zweites  ausgestattetes Bad vorhanden',
            4: 'Modernisiertes Bad',
            5: 'Keine dieser Ausstattungen'

        },
        kueche: {
            null: "",
            0: 'Zum Ess-/Wohnraum offene Küche',
            1: 'Anderer Küchentyp'
        },
        kuechengrundausstattung: {
            null: "",
            0: 'Ja',
            1: 'Nein'
        },
        elektrogeraete: {
            0: 'Glaskeramik-Kochmulde (Ceranfeld) oder Induktionskochfeld',
            1: 'Kühlschrank oder Kühl-/Gefrierkombination',
            2: 'Geschirrspülmaschine',
            3: 'Keines dieser Elektrogeräte zusätzlich zur Grundausstattung',
            error: 'Zuschläge für Elektrogeräte dürfen nur vergeben werden, wenn Ihr*e Vermieter*in als Grundausstattung eine Spülmöglichkeit und Einbauschränke (auch Kücheninsel/Küchenblock) zur Verfügung gestellt hat',
        },
        Fussboden: "Fußboden",
        fussboden: {
            null: "",
            0: 'Ohne Fußbodenbelag',
            1: 'Einfacher Boden',
            2: 'Guter Boden',
            3: 'Weder "Ohne Fußbodenbelag" noch "Einfacher Boden" beziehungsweise "Guter Boden"',
            error: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Fußboden" die Auswahl von "%{currentChoice}" aus.'
        },
        ModernisierterBoden: "Modernisierter Boden",
        modernisierterBoden: {
            null: "",
            0: 'Ja',
            1: 'Nein'
        },
        TerrasseBalkon: "Terrasse/Dachterrasse/Balkon/Loggia",
        terrasseBalkon: {
            null: "",
            0: 'Ja',
            1: 'Nein',
            balkonABError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Ausrichtung des Balkons/ der Loggia" die Auswahl von "Nein" (ohne Balkon/Loggia/Terrasse/Dachterrasse) aus.',
            balkonGrossError: 'Im Berechnungsschritt "Begründete Abweichungen" schließt die Eingabe einer begründeten Abweichung für "Ein Balkon/Loggia größer als 10 m²" die Auswahl von "%{currentChoice}" aus.'
        },
        ModernisierteFenster: "Modernisierte Fenster",
        modernisierteFenster: {
            null: "",
            0: 'Ja',
            1: 'Nein'
        },
        besondereAusstattung: {
            null: "",
            0: 'Ja',
            1: 'Nein'
        },
        abweichungen: {
            text: 'Für Abweichungen von der durchschnittlichen ortsüblichen Miete ist eine Begründung erforderlich. Sofern zutreffend, geben Sie bitte die Höhe der jeweiligen Abweichung ein. Bitte beachten Sie die Hinweise zu Grenzwerten und maximalen Abweichungen im Infoblock.',
            nein: 'Nein',
            generalError: "Berechnung ist nicht möglich, bitte lösen Sie erst Ihre Konflikte!",
            wasser: "<strong class='merkmalTitle'>Unterschiedliche oder unvollständige Warmwasserversorgung:</strong><br>(für einen Ansatz muss eines der beiden Merkmale zutreffen)",
            wasserBerechnung: "Unterschiedliche oder unvollständige Warmwasserversorgung:",
            wasserText: "(für einen Ansatz muss eines der beiden Merkmale zutreffen)",
            wasserAText: "<strong class='merkmalTitle'>a) Unterschiedliche Warmwasserversorgung</strong><br> Die Warmwasserversorgung ist in Küche und Bad von der*dem Vermieter*in gestellt und erfolgt auf unterschiedliche Arten, zum Beispiel durch einen Boiler in der Küche und einer Warmwasserversorgung über die Gebäude-Zentralheizung im Badezimmer.",
            wasserBText: "<strong class='merkmalTitle'>b) Unvollständige Warmwasserversorgung</strong><br> Eine von der*dem Vermieter*in gestellte Warmwasserversorgung ist entweder in Küche oder Bad, aber nicht in beiden Räumen vorhanden.",
            wasserValidation: 'Geben Sie hier einen Wert zwischen -0,70 Euro und +0,00 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            rueckgebaeude: "<strong class='merkmalTitle'>Rückgebäude</strong>",
            rueckgebaeudeBerechnung: "Rückgebäude",
            rueckgebaeudeText: "Wohnung in einem Rückgebäude mit einem Baujahr nach 1948.<br><strong>Hinweis:</strong> Ein Rückgebäude ist ein eigenständiges Gebäude mit eigenem Eingang. Die Erschließung erfolgt über das Hauptgebäude (Durchgang / Durchfahrt / seitlich am Hauptgebäude vorbei). Das Rückgebäude muss nicht zwingend freistehend sein. Es kann daher direkt an das Hauptgebäude, aber auch an ein anderes Gebäude angrenzen.",
            rueckgebaeudeValidation: 'Geben Sie hier einen Wert zwischen 0,00 Euro und +0,70 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            waermedaemmung: "<strong class='merkmalTitle'>Wärmedämmung der Außenwände:</strong>",
            waermedaemmungBerechnung: "Wärmedämmung der Außenwände:",
            waermedaemmungText: "Wohnung in einem Gebäude mit einem Baujahr nach 1948 und vor 1999, bei dem seit 2019 eine Wärmedämmung einzelner oder aller Außenwände erfolgte. <br><strong>Hinweis:</strong> Es kommt nicht darauf an, ob es sich um Modernisierungen oder Instandsetzungen handelt.",
            waermedaemmungValidation: 'Geben Sie hier einen Wert zwischen 0,00 Euro und +0,90 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            fassade: "<strong class='merkmalTitle'>Besonders gestaltete Fassade:</strong>",
            fassadeBerechnung: "Besonders gestaltete Fassade",
            fassadeText: "Wohnung in einem Gebäude mit einem Baujahr vor 1949, das",
            fassadeAText: "a) über eine <strong>besonders gestaltete Fassade</strong> (zum Beispiel Stilfassade) verfügt:",
            fassadeA: "besonders gestaltete Fassade",
            fassadeBText: "b) <strong>nicht</strong> über eine besonders gestaltete Fassade (zum Beispiel Stilfassade) verfügt:",
            fassadeB: "nicht über eine besonders gestaltete Fassade",
            fassadeAValidation: 'Geben Sie hier einen Wert zwischen 0,00 Euro und +0,40 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            fassadeBValidation: 'Geben Sie hier einen Wert zwischen -0,25 Euro und +0,00 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            zusatz: "<strong class='merkmalTitle'>Zusätzliche Begründungen:</strong>",
            zusatzBerechnung: "Zusätzliche Begründungen",
            zusatzText: 'Zusätzliche Begründungen sind möglich, wenn die Wohnung erheblich vom Standard der <a href="/berechnung.html#/zuschlaege">Zu- und Abschlagsmerkmale</a> abweicht, oder wenn bei diesen sogenannte Schwellenwerte (siehe Infoblock) auftreten. Maximal kann hier eine Abweichung bis in Höhe der entsprechenden Beträge der jeweiligen <a href="/berechnung.html#/zuschlaege">Zu- und Abschlagsmerkmale</a> angesetzt werden. Sonstige, durch das Berechnungsprogramm unzureichend erfasste <a href="/berechnung.html#/zuschlaege">Merkmale</a> können bei besonderer Begründung berücksichtigt werden (Angaben hierzu können auf der Seite "Berechnungsergebnisse" im Textfeld "Adressen und Begründungen" gemacht werden).',
            zusatzValidation: 'Geben Sie hier einen Wert zwischen -4,50 Euro und +4,00 Euro ein. Bitte ändern Sie Ihre Eingabe.',
            rueckgebaeudeError: "Das Merkmal Rückgebäude findet nur Anwendung, wenn im Berechnungsschritt \"Baujahr\" ein Baujahr nach 1948 ausgewählt wurde.",
            waermedaemmungError: "Das Merkmal Wärmedämmung der Außenwände findet nur Anwendung, wenn im Berechnungsschritt \"Baujahr\" ein Baujahr nach 1948 und vor 1999 ausgewählt wurde.",
            fassadeAError: "Das Merkmal besonders gestaltete Fassade findet nur Anwendung, wenn im Berechnungsschritt \"Baujahr\" ein Baujahr vor 1949 ausgewählt wurde."
        },
        betriebskosten: {
            a0: 'Ortsübliche Miete ohne Betriebskosten (Nettomiete)',
            a1: 'Mit allen Betriebskosten (Bruttomiete) beziehungsweise teilweise mit Betriebskosten (Teilinklusivmiete)',
            0: 'Wasser/Abwasser',
            1: 'Straßenreinigung',
            2: 'Müllabfuhr',
            3: 'Grundsteuer',
            4: 'Sach- und Haftpflichtversicherung',
            5: 'Kaminkehrer*in (soweit nicht bei Heizkosten)',
            6: 'Hausbeleuchtung',
            7: 'Aufzug',
            8: 'Waschmaschine',
            9: 'Hausmeister*in',
            10: 'Gartenpflege (soweit nicht bei Hausmeister*in)',
            11: 'Hausreinigung (soweit nicht bei Hausmeister*in)',
            12: 'Schneebeseitigung (soweit nicht bei Hausmeister*in)',
            13: 'Reinigung/Wartung von Etagenheizung, Warmwasser-Geräten (soweit keine weiteren Kosten für Brennstoff abgerechnet werden)',
            14: 'Heizung/Warmwasser',
            15: 'Gemeinschaftsantenne',
            16: 'Satellitenschüssel',
            17: 'Kabelfernsehen',
            footnote: '* Es kann bei "Gemeinschaftsantenne, Satellitenschüssel, Kabelfernsehen" zu rundungsbedingten Abweichungen bei den m²-Preisen kommen. Bitte stellen Sie nur auf die Gesamtmiete (Euro/Monat) ab!'
        },
        berechnungsvorlagen: {
            loadSuccess: 'Die Berechnung Nr. {dateiid} {dateiname} wurde erfolgreich geladen.',
            editSuccess: 'Die Berechnung Nr. {dateiid} {dateiname} wurde erfolgreich geändert.',
            saveSuccess: 'Die Berechnung Nr. {dateiid} {dateiname} wurde erfolgreich gespeichert.',
            deleteSuccess: 'Die Berechnung Nr. {dateiid} {dateiname} wurde erfolgreich gelöscht.',
            delete: 'Wollen Sie die Datei "<span class="font-weight-bold">{dateiname}</span>" wirklich löschen?'
        }
    }
};

const i18n = new VueI18n({
    locale: 'de', // set locale
    fallbackLocale: 'de', // set fallback locale
    messages, // set locale messages
});

export default i18n;